if (!customElements.get('pickup-availability')) {
  customElements.define('pickup-availability', class PickupAvailability extends HTMLElement {
    constructor() {
      super();

      if(!this.hasAttribute('available')) return;

      this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
      this.onClickRefreshList = this.onClickRefreshList.bind(this);
      this.fetchAvailability(this.dataset.variantId);
      this.pickupAvailabilityDrawer = this.querySelector('pickup-availability-drawer');
    }

    fetchAvailability(variantId) {
      let rootUrl = this.dataset.rootUrl;
      if (!rootUrl.endsWith("/")) {
        rootUrl = rootUrl + "/";
      }
      const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

      fetch(variantSectionUrl)
        .then(response => response.text())
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('.shopify-section');
          this.renderPreview(sectionInnerHTML);
        })
        .catch(e => {
          const button = this.querySelector('button');
          if (button) button.removeEventListener('click', this.onClickRefreshList);
          this.renderError();
        });
    }

    onClickRefreshList(evt) {
      this.fetchAvailability(this.dataset.variantId);
    }

    renderError() {
      this.innerHTML = '';
      this.appendChild(this.errorHtml);

      this.querySelector('button').addEventListener('click', this.onClickRefreshList);
    }

    renderPreview(sectionInnerHTML) {
      if (this.drawer) this.drawer.remove();
      this.drawer = null;
      if (!sectionInnerHTML.querySelector('pickup-availability-preview')) {
        this.innerHTML = "";
        this.removeAttribute('available');
        return;
      }

      this.innerHTML = sectionInnerHTML.querySelector('pickup-availability-preview').outerHTML;
      this.setAttribute('available', '');

      // The drawer lives on <body> so it can overlay the page, but it belongs to
      // this element: removed with it (quick-view content replaced, section
      // re-rendered) and re-attached if the element is moved. Otherwise it
      // outlives the stylesheet the quick-view content carried and renders
      // unstyled at the bottom of the page.
      this.drawer = sectionInnerHTML.querySelector('pickup-availability-drawer');
      document.body.appendChild(this.drawer);

      const button = this.querySelector('button');
      if (button) button.addEventListener('click', (evt) => {
        if (this.drawer) this.drawer.show(evt.target);
      });
    }

    connectedCallback() {
      if (this.drawer && !this.drawer.isConnected) document.body.appendChild(this.drawer);
    }

    disconnectedCallback() {
      if (this.drawer) this.drawer.remove();
    }
  });
}

if (!customElements.get('pickup-availability-drawer')) {
  customElements.define('pickup-availability-drawer', class PickupAvailabilityDrawer extends HTMLElement {
    constructor() {
      super();

      this.onBodyClick = this.handleBodyClick.bind(this);
      this.backDrop = document.getElementById('base-backdrop');

      this.closeButton = this.querySelector(
        'button[data-modal-close], ' +
        'button.pickup-availability-drawer-button, ' +  // ← Your actual class
        '.pickup-availability-drawer__close, ' +
        '.base-modal__close'
      );
      
      if (this.closeButton) {
        this.closeButton.addEventListener('click', () => {
          this.hide();
        });
      }

      this.addEventListener('keyup', (event) => {
        if(event.code.toUpperCase() === 'ESCAPE') this.hide();
      });
    }

    handleBodyClick(evt) {
      const target = evt.target;
      if (target != this && !target.closest('pickup-availability-drawer') && target.id != 'ShowPickupAvailabilityDrawer') {
        this.hide();
      }
    }

    hide() {
      this.removeAttribute('open');
      document.body.removeEventListener('click', this.onBodyClick);
      document.documentElement.classList.remove('overflow-hidden');
      document.documentElement.style.paddingRight = "";
      if (this.backDrop) this.backDrop.classList.remove('active');
      
      removeTrapFocus(this.focusElement);
    }

    show(focusElement) {
      this.focusElement = focusElement;
      this.setAttribute('open', '');
      document.body.addEventListener('click', this.onBodyClick);
      const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.documentElement.classList.add('overflow-hidden');
      document.documentElement.style.paddingRight = scrollBarWidth + "px";
      if (this.backDrop) this.backDrop.classList.add('active');
      
      requestAnimationFrame(() => {
        if (this.closeButton) {
          this.closeButton.removeAttribute('tabindex');
        }
        
        trapFocus(this, this.closeButton || this);
        if (this.closeButton) {
          setTimeout(() => {
            this.closeButton.focus();
          }, 50);
        }
      });
    }
  });
}
